module.exports = __webpack_public_path__ + "img/002-wind-12.9c3dd356.svg";